import React from 'react';
import PropTypes from 'prop-types';
import {
  TableHead, TableRow,
} from '@material-ui/core';
import MyTableHeadCell from './MyTableHeadCell';
import { myTableHeadCellPropTypes } from './my-table-prop-types';


const MyTableHead = (props) => {
  const {
    idTable,
    headers,
    orderBy,
    orderDirection,

    onRequestSort,
  } = props;

  return (
    <TableHead>
      <TableRow>
        {
          headers.map((header) => (
            <MyTableHeadCell
              key={`MyTableHeader-${idTable}-header-${header.name}`}
              name={header.name}
              type={header.type}
              align={header.align}
              padding={header.padding}
              sorting={header.sorting}
              labelId={header.labelId}
              orderBy={orderBy}
              orderDirection={orderDirection}
              onRequestSort={onRequestSort}
            />
          ))
        }
      </TableRow>
    </TableHead>
  );
};

MyTableHead.propTypes = {
  idTable: PropTypes.string.isRequired,
  headers: PropTypes.arrayOf(PropTypes.shape(myTableHeadCellPropTypes)),
  orderBy: PropTypes.string.isRequired,
  orderDirection: PropTypes.string.isRequired,

  onRequestSort: PropTypes.func,
};

MyTableHead.defaultProps = {
  headers: [],
  onRequestSort: undefined,
};

export default MyTableHead;
